import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ScheduleDetails } from "src/app/common/interfaces/home/schedule-details.interface";
import { AppConstants } from "src/app/common/constants/app-constants";
import { Router } from "@angular/router";
import { LandingPageService } from "../services/landing-page.service";
import { StorageService } from "src/app/common/services/storage.service";
import { distinctUntilChanged, Subscription } from "rxjs";
import { LandingClientService } from "src/app/common/services/landing-page.client";
import {
  ButtonVariant,
  ButtonComponent,
} from "src/app/common/components/core/button/button.component";
import { ConfirmationModalComponent } from "src/app/common/components/core/modal/confirmation-modal/confirmation-modal.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-schedule",
  standalone: true,
  imports: [CommonModule, ButtonComponent],
  templateUrl: "./schedule.component.html",
  styleUrls: ["./schedule.component.scss"],
})
export class ScheduleComponent implements OnInit {
  schedules!: ScheduleDetails;
  emDash = AppConstants.emDash;
  facilityId: string | null = "";
  private facilitySubscription: Subscription | null = null;
  scheduleReport!: any;
  buttonVariant = ButtonVariant;
  constructor(
    private router: Router,
    private landingScreenService: LandingPageService,
    private storageService: StorageService,
    private landingClientService: LandingClientService,
    private matDialog: MatDialog
  ) {}

  async ngOnInit() {
    this.facilitySubscription = this.storageService.isSelectedFacility
      .pipe(distinctUntilChanged())
      .subscribe((facilityId) => {
        this.facilityId = facilityId;
        this.getScheduleDetails();
      });
  }

  ngOnDestroy() {
    this.facilitySubscription?.unsubscribe();
  }

  async getScheduleDetails() {
    this.schedules =
      await this.landingScreenService.getScheduleAndBillingDetails();
  }

  routeToPatientProfile(patientId: string) {
    this.router.navigateByUrl(
      `/patient/${this.facilityId}/profile/${patientId}`
    );
  }

  printScheduleReport(): void {
    if (!this.facilityId) return;

    this.landingClientService.getScheduledReport(this.facilityId).subscribe(
      (response) => {
        if (response.body != null) {
          const date = new Date().toISOString().split("T")[0];
          const user = JSON.parse(this.storageService.getUser()!);
          const therapistName = user.fullname;

          const filename = `TherapistAgenda_${date}_${therapistName}.xlsx`;

          const fileURL = URL.createObjectURL(response.body);

          const a = document.createElement("a");
          a.href = fileURL;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          URL.revokeObjectURL(fileURL);
        }
      },
      (error) => {
        this.displayErrorModal(error);
      }
    );
  }

  private displayErrorModal(error: any): void {
    this.matDialog.open(ConfirmationModalComponent, {
      data: {
        title: "Error",
        message: "No Agenda is present for the day",
        buttonText: "OK",
        hideCancelButton: true,
        isError: true,
      },
    });
  }
}
